import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { getToken } from "../../../utils/tokenService";
import defaultProfile from "../../../assets/Default_pfp.svg.png";
import Papa from "papaparse";
import { FaDownload } from "react-icons/fa";

const ActiveEmployees = () => {
  const [users, setUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const token = await getToken();
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/client/users`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const list = res.data?.users || res.data?.activeUsers || [];
        setUsers(list);
        setFiltered(list);
      } catch (err) {
        toast.error("Failed to load employees");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const onSearch = (e) => {
    const q = e.target.value.toLowerCase();
    const f = users.filter((u) =>
      (u.full_Name || "").toLowerCase().includes(q) ||
      (u.employeeId || "").toString().includes(q)
    );
    setFiltered(f);
  };

  const downloadCSV = () => {
    if (!filtered.length) {
      toast.info("No data to export");
      return;
    }
    const selectedFields = filtered.map((u) => ({
      EmployeeId: u.employeeId ? `CMPL${u.employeeId}` : "",
      Name: u.full_Name,
      Contact: u.contact,
      Email: u.email,
      Aadhar: u.aadhar_number,
      DOB: u.dob,
      Gender: u.gender,
      Country: u.country,
      State: u.state,
      District: u.dist,
      Zip: u.zip,
      PAN: u.pan_number,
      PAN_Name: u.pan_name,
      Account_No: u.account_number,
      IFSC: u.account_ifsc,
      UAN: u.uan_number,
      EPF: u.epf_number,
      ESI: u.esi_number,
      DOJ: u.date_of_joining,
      Basic: u.basic,
      DA: u.da,
      HRA: u.hra,
      OtherAllowance: u.other_allowance,
      LeaveWithWages: u.leave_with_wages,
    }));
    const csv = Papa.unparse(selectedFields);
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "client_employees.csv";
    a.click();
  };

  if (loading) return <div className="p-4">Loading...</div>;

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-3 gap-3 flex-wrap">
        <h4 className="mb-0">Employees</h4>
        <div className="d-flex gap-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name or ID"
            onChange={onSearch}
            style={{ minWidth: "220px" }}
          />
          <button className="btn btn-outline-secondary" onClick={downloadCSV}>
            <FaDownload className="me-1" /> Export
          </button>
        </div>
      </div>
      {!filtered.length ? (
        <p className="text-muted">No employees found.</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped align-middle">
            <thead className="table-light">
              <tr>
                <th>Employee ID</th>
                <th>Name</th>
                <th>Contact</th>
                <th>Email</th>
                <th>Aadhar</th>
                <th>DOB</th>
                <th>Gender</th>
                <th>Country</th>
                <th>State</th>
                <th>District</th>
                <th>ZIP</th>
                <th>UAN</th>
                <th>EPF</th>
                <th>ESI</th>
                <th>DOJ</th>
                <th>Basic</th>
                <th>DA</th>
                <th>HRA</th>
                <th>Other Allow.</th>
                <th>Leave w/ Wages</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((u) => (
                <tr key={u._id}>
                  <td>{u.employeeId ? `CMPL${u.employeeId}` : "N/A"}</td>
                  <td className="fw-semibold">{u.full_Name || "N/A"}</td>
                  <td>{u.contact || ""}</td>
                  <td>{u.email || ""}</td>
                  <td>{u.aadhar_number || ""}</td>
                  <td>{u.dob || ""}</td>
                  <td>{u.gender || ""}</td>
                  <td>{u.country || ""}</td>
                  <td>{u.state || ""}</td>
                  <td>{u.dist || ""}</td>
                  <td>{u.zip || ""}</td>
                  <td>{u.uan_number || ""}</td>
                  <td>{u.epf_number || ""}</td>
                  <td>{u.esi_number || ""}</td>
                  <td>{u.date_of_joining || ""}</td>
                  <td>{u.basic || ""}</td>
                  <td>{u.da || ""}</td>
                  <td>{u.hra || ""}</td>
                  <td>{u.other_allowance || ""}</td>
                  <td>{u.leave_with_wages || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ActiveEmployees;
